import { Card, Typography, Skeleton } from "antd";
import classNames from "classnames";
import PropTypes from "prop-types";
import "./CardSimple.less";

const CardSimple = ({
  title,
  icon,
  secondaryTitle,
  loading,
  fixedWidth,
  extra,
  children,
}) => {
  const { Title, Paragraph } = Typography;

  return (
    <Card
      className={classNames("card-simple", {
        "-fixed-width": fixedWidth,
      })}
      extra={extra}
      title={
        <>
          <Title level={5} className="secondary-title">
            {loading ? (
              <Skeleton paragraph={false} title={{ width: "100px" }} />
            ) : (
              secondaryTitle
            )}
          </Title>
          <Title level={2} className="title">
            {loading ? (
              <Skeleton paragraph={false} title={{ width: "200px" }} />
            ) : (
              <>
                {icon} {title}
              </>
            )}
          </Title>
        </>
      }
    >
      <Paragraph type="secondary">
        {loading ? <Skeleton paragraph={false} /> : children}
      </Paragraph>
    </Card>
  );
};

CardSimple.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.element,
  secondaryTitle: PropTypes.string,
  loading: PropTypes.bool,
  fixedWidth: PropTypes.bool,
  extra: PropTypes.node,
  children: PropTypes.node,
};

export default CardSimple;
